import React, { useContext, useEffect, useState } from 'react'
import {
  Box,
  Button,
  Chip,
  Dialog,
  Divider,
  Fade,
  IconButton,
  Paper,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import LockRoundedIcon from '@mui/icons-material/LockRounded'
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded'
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import { motion } from 'framer-motion'
import { getCustomerTier } from '../../helpers/TierLimits'
import { GlobalContext, UserContext } from '../../App'
import { useNavigate } from 'react-router-dom'
import { Home } from '@mui/icons-material'
import UpgradeRequiredPage from '../Subscriptions/UpgradeRequiredPage'
import SubscriptionGate from '../Subscriptions/SubscriptionGate'

const MotionPaper = motion.create(Paper)

export default function UpgradeRequired() {
  const theme = useTheme()
  const { user } = useContext(UserContext)
  const { setUpgradeRequired, upgradeRequired } = useContext(GlobalContext)
  const navigate = useNavigate()

  const isBillPayer = user?.security?.isSiteAdmin ?? false
  const [currentTier, setCurrentTier] = useState(null)

  return (
    <Fade in={!!upgradeRequired} timeout={400}>
      <Box
        sx={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          p: 3,
          backdropFilter: 'blur(6px)',
          background: 'rgba(15,23,42,0.12)',
        }}
      >
        <UpgradeRequiredPage
          requiredTier={upgradeRequired?.requiredTier}
          featureName={upgradeRequired?.featureName}
          benefits={upgradeRequired?.benefits}
          limitInfo={upgradeRequired?.limitReached ? upgradeRequired : null}
          setUpgradeRequired={setUpgradeRequired}
        />
      </Box>
    </Fade>
  )
}
